declare global {
  interface CustomGlobalConstants {
    READER_BASE_URL?: string;
  }
}

/**
 * moving the globalThis reference to a constant
 * allows the minifier to better reduce variables names
 *
 * that's a small hack which should be limited to specific use cases.
 */
export const global = globalThis as unknown as (
  | Window
  | WorkerGlobalScope
  | ServiceWorkerGlobalScope
) &
  CustomGlobalConstants &
  typeof globalThis;

export const document = /* @__PURE__ */ (() => global.document)();
export const Promise = /* @__PURE__ */ (() => global.Promise)();

export const READER_BASE_URL = /* @__PURE__ */ (() =>
  global.READER_BASE_URL || "")();
